import { memo } from 'react';

import { InceptIcon, InceptIconProps } from '../InceptIcon';

const IconAssetGreenGoodsComponent: React.FC<InceptIconProps> = ({
  color = 'var(--chakra-colors-brand-primary-fg, currentColor)',
  brandColor = 'var(--chakra-colors-brand-primary-solid)',
  fillColor = 'var(--chakra-colors-brand-primary-contrast)',
  viewBox = '0 0 80 80',
  ...props
}: InceptIconProps) => (
  <InceptIcon viewBox={viewBox} {...props}>
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="0.75"
    >
      <path
        d="M34.063 21.095c-5.167 2.98-9.355 10.234-9.355 16.202 0 2.9.987 4.96 2.594 5.967.127.08 2.694 1.534 2.694 1.534s.04-1.58 2.5-3.008c5.167-2.98 9.355-10.234 9.355-16.202 0-2.893 1.607-3.54 1.607-3.54s-2.84-1.653-2.947-1.707c-1.68-.88-3.954-.7-6.455.747z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M36.983 22.781c-5.167 2.98-9.354 10.235-9.354 16.202s4.187 8.382 9.354 5.401c5.168-2.98 9.355-10.234 9.355-16.202 0-5.967-4.187-8.381-9.355-5.4Z"
        fill={color}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M15.86 42.704C12.62 44.57 10 49.11 10 52.852c0 1.813.62 3.107 1.627 3.74.08.047 1.687.96 1.687.96s.026-.993 1.567-1.88c3.233-1.867 5.86-6.414 5.86-10.148 0-1.813 1.007-2.22 1.007-2.22s-1.78-1.034-1.847-1.067c-1.053-.553-2.473-.44-4.04.467Z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M17.688 43.757c-3.234 1.867-5.86 6.415-5.86 10.148 0 3.734 2.62 5.248 5.86 3.38 3.234-1.866 5.86-6.413 5.86-10.147s-2.62-5.254-5.86-3.38ZM27.562 35.103l6.04 18.356 9.069 5.234V41.61l-15.109-8.722zM36.023 30.882l15.109 8.721L66.7 30.616l-15.108-8.728z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m27.562 32.89 15.109 8.72 1.813-11.894-15.108-8.728z"
        fill={brandColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m29.376 20.988 15.109 8.728L60.06 20.72 44.95 12z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M60.06 20.721 44.49 29.71l-1.813 11.895v17.082l5.1-2.947q-.272-1.2-.273-2.64c0-6.968 4.895-15.442 10.929-18.93 3.313-1.913 6.274-1.92 8.28-.393v-3.174l-4.913-.22-1.727-9.667z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m44.265 40.69 11.961-6.907v-9.348l-10.501 6.06z"
        fill={brandColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M58.626 35.27c-5.167 2.98-9.354 10.234-9.354 16.202 0 2.9.986 4.96 2.593 5.967.127.08 2.694 1.534 2.694 1.534s.04-1.58 2.5-3.007c5.168-2.98 9.355-10.235 9.355-16.202 0-2.894 1.606-3.54 1.606-3.54s-2.84-1.654-2.947-1.708c-1.68-.88-3.953-.7-6.454.747z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M61.54 36.963c-5.167 2.98-9.355 10.235-9.355 16.202s4.188 8.381 9.355 5.4 9.355-10.234 9.355-16.201-4.188-8.381-9.355-5.4Z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M61.54 41.097c-3.187 1.84-5.774 6.314-5.774 9.995s2.587 5.174 5.774 3.333c3.187-1.84 5.774-6.314 5.774-9.994s-2.587-5.174-5.774-3.334Z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M58.56 33.503c-6.528 3.767-11.662 13.041-11.662 20.582q.002.86.093 1.66l1.86 1.087c-.033-.746.227-2.053.227-3.013 0-6.955 6.741-15.662 10.368-17.976s5.548-3.1 7.548-1.574l1.953-.433-1.86-1.087c-2.213-1.267-5.38-1.067-8.52.754zM12.474 55.086l13.455 7.767v-6.427l-13.455-7.768z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m12.474 48.658 13.455 7.768 4.467-7.768L16.94 40.89z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="m16.94 40.89 13.456 7.768 10.621-6.134-13.455-7.768z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M25.929 56.426v6.427l11.494-4.64 3.594-.474V42.524l-10.621 6.134z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M33.663 52.619c-3.234 1.866-5.86 6.414-5.86 10.148 0 1.813.62 3.107 1.626 3.74.08.047 1.687.96 1.687.96s.027-.993 1.567-1.88c3.234-1.867 5.86-6.414 5.86-10.148 0-1.814 1.007-2.22 1.007-2.22s-1.78-1.034-1.846-1.067c-1.054-.554-2.474-.44-4.041.466Z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M35.49 53.672c-3.234 1.867-5.861 6.414-5.861 10.148s2.62 5.247 5.86 3.38c3.234-1.867 5.861-6.414 5.861-10.148s-2.62-5.254-5.86-3.38Z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M35.383 56.58c-1.993 1.153-3.614 3.953-3.614 6.26s1.62 3.24 3.614 2.087 3.614-3.954 3.614-6.261-1.62-3.24-3.614-2.087Z"
        fill={fillColor}
        stroke={color}
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </InceptIcon>
);

export const IconAssetGreenGoods = memo(IconAssetGreenGoodsComponent);
